import React from 'react'
import PropTypes from 'prop-types'

export default function InputGroupTitle ({ children }) {
    return (
        <div className={'input-group-title'}>
            { children }
        </div>
    )
}

InputGroupTitle.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array])
}